import React, { useState, useEffect } from "react";
import "./poin.css";
const REACT_APP_EXPRESS_API = process.env.REACT_APP_EXPRESS_API;

const BASE_URL = `${REACT_APP_EXPRESS_API}`; // sesuaikan kalau perlu

// Helper: format YYYY-MM-DD pakai waktu lokal (hindari offset ISO)
const toYMD = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// Range bulan ini: dari tanggal 1 s/d hari ini
const getMonthRange = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1); // awal bulan (lokal)
  const end = now; // hari ini
  return { startDate: toYMD(start), endDate: toYMD(end) };
};

// Helper: coba ambil totalPoints dari berbagai bentuk response
const extractTotalPoints = (data) => {
  if (!data) return 0;
  // { success: true, data: { totalPoints: 123 } }
  if (typeof data === "object" && "data" in data && data.data) {
    if (typeof data.data.totalPoints !== "undefined") return Number(data.data.totalPoints) || 0;
  }
  // { totalPoints: 123 }
  if (typeof data.totalPoints !== "undefined") return Number(data.totalPoints) || 0;
  // [ { totalPoints: 123 } ]
  if (Array.isArray(data) && data.length > 0 && typeof data[0]?.totalPoints !== "undefined") {
    return Number(data[0].totalPoints) || 0;
  }
  return 0;
};

export default function Poin() {
  const [activeTab, setActiveTab] = useState("bulanan");
  const [monthlyPoints, setMonthlyPoints] = useState(0);
  const [totalPoints, setTotalPoints] = useState(0);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(false);

  // Ambil poin total & bulanan
  useEffect(() => {
    const { startDate, endDate } = getMonthRange();

    const token = localStorage.getItem("accessToken");
    const headers = token
      ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
      : { "Content-Type": "application/json" };

    // --- Fetch total poin ---
    fetch(`${BASE_URL}/api/transactions/poins`, {
      headers,
      credentials: "include", // penting! kirim cookie juga
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        const total = extractTotalPoints(data);
        setTotalPoints(Number(total) || 0);
      })
      .catch((err) => console.error("Fetch total points", err));

    // --- Fetch poin bulanan ---
    const qp = new URLSearchParams({ startDate, endDate }).toString();
    fetch(`${BASE_URL}/api/transactions/poins?${qp}`, {
      headers,
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        const monthly = extractTotalPoints(data);
        setMonthlyPoints(Number(monthly) || 0);
      })
      .catch((err) => console.error("Fetch monthly points", err));
  }, []);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      setLoading(true);

      try {
        const token = localStorage.getItem("accessToken");
        const headers = token
          ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
          : { "Content-Type": "application/json" };

        // Tentukan URL tergantung tab aktif
        let url = `${BASE_URL}/api/leaderboard`;
        if (activeTab === "bulanan") {
          const { startDate, endDate } = getMonthRange();
          const qp = new URLSearchParams({ startDate, endDate }).toString();
          url = `${BASE_URL}/api/leaderboard?${qp}`;
        }

        const res = await fetch(url, {
          headers,
          credentials: "include", // penting agar cookie session terkirim
        });

        if (!res.ok) throw new Error(`Gagal fetch leaderboard (${res.status})`);

        const data = await res.json();

        // Support berbagai bentuk respons
        let lb = [];
        if (Array.isArray(data)) {
          lb = data;
        } else if (Array.isArray(data?.leaderboard)) {
          lb = data.leaderboard;
        } else if (Array.isArray(data?.data)) {
          lb = data.data;
        }

        setLeaderboard(lb || []);
      } catch (error) {
        console.error("Fetch leaderboard", error);
        setLeaderboard([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [activeTab]);

  return (
    <div className="poin-container">
      <div className="breadcrumb-poin">
        <span className="breadcrumb-item">Halaman</span>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-item active">Poin</span>
      </div>

      <h2>Poin</h2>
      <div className="poin-header">
        <div className="poin-text">
          <h2>Keaktifan Pengguna</h2>
          <p className="poin-desc">
            <strong>Catat</strong> rutin, <strong>pantau</strong> progres, dan <strong>lihat</strong> bagaimana kebiasaan kecil membangun finansial yang lebih sehat.
          </p>
          <p className="poin-desc">
            Setiap aktivitas yang kamu lakukan di platform kami akan memberikanmu poin sebagai bentuk apresiasi.<br />
            Poin yang terkumpul dapat ditukarkan dengan berbagai voucher menarik atau layanan eksklusif di website ini.
          </p>
          <p className="poin-desc-2">
            Nikmati pengalaman terbaik bersama kami, semakin aktif kamu, semakin banyak hadiah yang menantimu!
          </p>
        </div>

        <div className="poin-image">
          <img src="/Images/poin.png" alt="Logo" />
        </div>
      </div>

      <div className="poin-content">
        {/* LEFT SIDE - LEADERBOARD */}
        <div className="poin-left">
          <div className="leaderboard-tabs">
            <button
              className={activeTab === "bulanan" ? "active" : ""}
              onClick={() => setActiveTab("bulanan")}
            >
              Bulanan
            </button>
            <button
              className={activeTab === "overall" ? "active" : ""}
              onClick={() => setActiveTab("overall")}
            >
              Overall
            </button>
          </div>

          <h3>{activeTab === "bulanan" ? "Papan Peringkat Bulanan" : "Papan Peringkat Overall"}</h3>

          {loading ? (
            <p>Sedang memuat data...</p>
          ) : leaderboard.length === 0 ? (
            <p>Tidak ada data leaderboard.</p>
          ) : (
            <div className="leaderboard">
              {leaderboard.map((item, index) => (
                <div
                  key={item.userId ?? index}
                  className={`leaderboard-item ${item.isCurrentUser ? "current-user" : ""}`}
                >
                  <span className="rank">{index + 1}</span>
                  <span className="name">{item.username ?? item.name ?? "-"}</span>
                  <span className="points">{item.totalPoints ?? item.points ?? 0} Poin</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* RIGHT SIDE - POINT CARDS */}
        <div className="poin-right">
          <div className="poin-card orange">
            <p>Poin Kumulatif Bulan Ini</p>
            <h2>{monthlyPoints} Poin</h2>
          </div>
          <div className="poin-card blue">
            <p>Poin Keseluruhan</p>
            <h2>{totalPoints} Poin</h2>
          </div>
        </div>
      </div>
    </div>
  );
}
